const initialState = {};

function reducer(state = initialState, action) {
    if (action.type === 'APM_SERIES_DATAPOINT_SUCCESS') {
        return { ...state, [action.actionParams.id]: action.payload };
    }

    return state;
}

export default reducer;
